import type { MapGeometry, Point, Token, TokenGridSnappingSettings } from "../types";

export function defaultTokenGridSnapping(): TokenGridSnappingSettings {
  return { player: false, enemy: false, neutral: false };
}

export function normalizeTokenGridSnapping(value?: Partial<TokenGridSnappingSettings>): TokenGridSnappingSettings {
  return { ...defaultTokenGridSnapping(), ...value };
}

export function tokenUsesGridSnapping(settings: TokenGridSnappingSettings | undefined, token: Pick<Token, "type" | "effect">): boolean {
  return !token.effect && normalizeTokenGridSnapping(settings)[token.type];
}

export function snapTokenPosition(position: Point, size: number, geometry?: Pick<MapGeometry, "width" | "height">): Point {
  const safeSize = Number.isFinite(size) ? Math.max(0.25, size) : 1;
  const half = safeSize / 2; const offset = ((half % 1) + 1) % 1; const step = Math.min(1, safeSize);
  const snap = (value: number) => Math.round((value - offset) / step) * step + offset;
  const clampAxis = (value: number, extent?: number) => {
    if (!Number.isFinite(extent)) return value;
    if (extent! <= safeSize) return extent! / 2;
    return Math.max(half, Math.min(extent! - half, value));
  };
  return { x: clampAxis(snap(position.x), geometry?.width), y: clampAxis(snap(position.y), geometry?.height) };
}
